import { HttpClient } from "@angular/common/http";
import { Injectable } from "@angular/core";
import { Observable } from "rxjs";
import { map } from "rxjs/operators";
import { Itinerario } from './itinerario';
import { environment } from '../../../environments/environment';

@Injectable({
  providedIn: 'root'
})
export class ItinerarioService {

  private apiUrl = `${environment.api}/itinerarios`;

  constructor(private http: HttpClient) {}

  /** Lista todos os itinerários disponíveis (aceita resposta paginada ou array simples). */
  listarTodos(): Observable<Itinerario[]> {
    return this.http
      .get<Itinerario[] | { content: Itinerario[] }>(this.apiUrl)
      .pipe(map((res) => (Array.isArray(res) ? res : res?.content ?? [])));
  }
}
